import createApiThunk from '../../../ApplicationFactory'
import { type ITerm, type ITermListResponse } from '../../../models/Term'

export const getTermByIdApi = createApiThunk<ITerm>('getTermByIdApi', {
  url: '/api/terms/<urlId>',
  method: 'GET',
  headers: {
    Accept: 'application/cdg'
  }
})
